import service from './network';

export function queryFactoryListApi(data){
    return service.request({
        url: '/management/factory/query',
        method: 'post',
        data
    })
}

export function updateFactoryApi(data){
    return service.request({
        url: '/management/factory/update',
        method: 'put',
        data
    })
}

export function deleteFactoryApi(data){
    return service.request({
        url: '/management/factory/delete',
        method: 'delete',
        data
    })
}

export function queryFactoryStatisticsApi(data){
    return service.request({
        url: '/management/factory/statistics',
        method: 'post',
        data
    })
}

export function queryFactoryEquipmentApi(data){
    return service.request({
        url: '/management/factory/statistics/equipment',
        method: 'post',
        data
    })
}
